import React from "react";
import __ from "lodash";
import {Checkbox, FormControlLabel, FormHelperText, Paper} from "@material-ui/core";


const RequiredDays = (props) => {

  const days = [1,2,3,4,5,6,7];
  const requiredDays = [];
  for (let i=0; i<days.length; i++) {
    if (props.days && props.days.length === 7) {
      requiredDays.push({day: i + 1, checked: props.days[i] !== "."});
    } else {
      requiredDays.push({day:  i + 1 , checked: false});
    }
  }
  return (
    <Paper variant="outlined" checkchildren="true" style={{marginTop: -25}}>
      <div style={{marginTop: -13, marginLeft: 5, width: 120 }} >
        <Paper elevation={0}>
          <FormHelperText component="legend" variant={"filled"}> {props.label} </FormHelperText>
        </Paper>
      </div>
      {days.map(day => (
        <FormControlLabel
          checkchildren="true"
          value={day}
          style={{marginLeft: -6, marginRight: -6}}
          control={
            <Checkbox
              color="primary"
              name={day}
              checked={__.find(requiredDays, {day: day}).checked}
              disabled={props.disabled}
              onChange={e => {
                __.find(requiredDays, {day: parseInt(e.target.name)}).checked = e.target.checked;
                let updatedDays = "";
                for (let i=0; i<days.length; i++) {
                  const day = requiredDays[i];
                  updatedDays += day.checked ? (i+1).toString() : ".";
                }
                if (props.onChange)
                  props.onChange(updatedDays);
              }}
            />
          }
          label={day}
          labelPlacement="top"
        />
      ))}
    </Paper>
  )
}

export default RequiredDays;
